import React from "react";
import { Menu, MenuItem, Box, Tooltip } from "@material-ui/core";
import { LabelButton } from "./ButtonDropdown.styled";
import { useMenu } from "hooks";
import { useTranslation } from "react-i18next";

export interface DropdownMenuItem {
    id: string;
    label: string;
}

interface ButtonDropdownProps {
    label: string | JSX.Element;
    labelColor?: string;
    items: DropdownMenuItem[];
    skipTabIndexing?: boolean;
    onSelect(item: DropdownMenuItem): void;
}

// this component is the same as ButtonDropdown to be used only in annotations colors dropdown
// will show color instead of text
export const ButtonDropdownColors: React.FC<ButtonDropdownProps> = ({
    label,
    labelColor,
    items,
    skipTabIndexing,
    onSelect,
}) => {
    const { t } = useTranslation();
    const { handleClose, handleOpen, open, anchorEl } = useMenu();

    // eslint-disable-next-line
    const selectItem = (item: DropdownMenuItem) => (e: any) => {
        onSelect(item);
        handleClose(e);
    };

    return (
        <>
            <Tooltip title={t("campaign.annotations.label.color") || ""} interactive placement="top">
                <LabelButton onClick={handleOpen} colour={labelColor} tabIndex={skipTabIndexing ? -1 : undefined}>
                    {label}
                </LabelButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
                {items.map((item) => (
                    <MenuItem key={item.id} onClick={selectItem(item)}>
                        <Box width="16px" height="16px" bgcolor={item.id} border="1px solid black" />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
